import {createRoot, hydrateRoot} from 'react-dom/client';
import ContactUs from '../pages/ContactUs/ContactUs'
import "../index.css";
import "../pages/ContactUs/ContactUs.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<ContactUs {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <ContactUs {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).ContactUsVC = {mount, hydrate, unmount}